// extracted by mini-css-extract-plugin
module.exports = {"selector":"selector_selector__rwaqV"};